import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getInfoResponse } from "utils/common";
import { saveUserInfo } from "features/User/userSlice";
import { SERVICE } from "constants/global";
import paymentAPI from "api/paymentAPI";
import noticeAPI from "api/noticeAPI";

const getPayment = createAsyncThunk(
  "GET_PAYMENT",
  async (_arg, { dispatch, rejectWithValue }) => {
    try {
      const res = await Promise.all([
        paymentAPI.getPaymentList(_arg),
        noticeAPI.getInitNotice({ service: SERVICE }),
      ]);
      dispatch(saveUserInfo(getInfoResponse(res[0])));
      if( res[0].sorrypage == '0' && res[1].sorrypage == '0') {
        return {
          payment: null,
          notice: {},
          isInLine: true
        }
      }
      return {
        payment: res[0].data.payment,
        notice: res[1].message?.notice,
        isInLinePayment: res[0].sorrypage == '0' ? true : res[0].data.isInLine,
        isInLineNotice: res[1].sorrypage == '0' ? true : res[1].isInLine,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const getPaymentByDate = createAsyncThunk(
  "GET_PAYMENT_PAYMENT_BY_DATE",
  async (_arg, { dispatch, rejectWithValue }) => {
    try {
      const res = await paymentAPI.getPaymentByDate(_arg);
      dispatch(saveUserInfo(getInfoResponse(res)));
      return res.data.payment;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  payment: null,
  payment_info: null,
  noticesInit: null,
  isInLine: false
};

const paymentSlice = createSlice({
  name: "payment",
  initialState,
  extraReducers: {
    [getPayment.fulfilled]: (state, action) => {
      state.payment = action.payload.payment;
      state.payment_info = action.payload.payment?.payment_info;
      state.noticesInit = action.payload.notice;
      state.isInLine = action.payload.isInLine;
      state.isInLinePayment = action.payload.isInLinePayment;
      state.isInLineNotice = action.payload.isInLineNotice;
    },
    [getPaymentByDate.fulfilled]: (state, action) => {
      state.payment = action.payload;
    },
  },
});

const { reducer } = paymentSlice;
export { getPayment, getPaymentByDate };
export default reducer;
